// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';

export const createAgGridApi = gridApi => ({
    gridApi,
    type: actions.CREATE_PIP_HISTORY_REPORT_AG_GRID_API
});



// WEBPACK FOOTER //
// ./src/reports/pip-history/action-creators/create-ag-grid.js